import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinpune() {



  const cardData =
  {
    keyword: 'Swift Dzire on Rent in Pune',
    heading: 'Sanavi Travels: Swift Dzire on Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable Swift Dzire on Rent in Pune, providing safe, comfortable, and budget-friendly transportation for families, corporate travelers, tourists, and small groups within Pune and for outstation trips. Our fleet of Swift Dzire cars is well-maintained with spacious seating, air-conditioning, and adequate luggage space, ensuring a smooth and convenient travel experience. With professional chauffeurs, flexible local and outstation cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and hassle-free service. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, Aurangabad, Kolhapur, and Konkan. Choose Sanavi Travels for trusted Swift Dzire rental services in Pune, delivering comfort, safety, and a seamless travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha heritage. Once the seat of Peshwa Bajirao I, it features grand gateways like the Delhi Darwaza, massive stone walls, and lush gardens. Though partially destroyed by fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum with Gandhi’s artifacts, photographs, and historical documents, set amidst sprawling gardens and serene ambiance."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for extensive charitable work, making it Pune’s spiritual heartbeat."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore ancient ramparts, memorials, and viewpoints. The fort offers breathtaking views of the Sahyadri ranges and local cuisine near the summit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being in the city center, it maintains tranquility and showcases early Indian craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal depicts historical lifestyles and makes the museum invaluable for art and history enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are mesmerizing."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors seek relaxation, rejuvenation, and personal transformation here."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers provide a serene sanctuary. Families, joggers, and photographers enjoy peaceful walks here."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The reservoir and surrounding hills create picturesque scenery, especially during monsoon. Street vendors add charm, and the dam also serves as the gateway to Sinhagad Fort, making it ideal for weekends and family outings."
  }
]
,




"services": [
  {
    "name": "Swift Dzire on Rent in Pune",
    "description": "Rent a Swift Dzire in Pune for comfortable and convenient travel, ideal for local or outstation trips."
  },
  {
    "name": "Swift Dzire Cab Hire Pune",
    "description": "Reliable Swift Dzire cab hire service in Pune with flexible rental options for daily or long-distance travel."
  },
  {
    "name": "AC Dzire Cab Pune",
    "description": "Air-conditioned Swift Dzire cabs providing a cool and comfortable ride within Pune or to nearby destinations."
  },
  {
    "name": "Dzire Taxi Service Pune",
    "description": "Efficient Dzire taxi service in Pune for local commutes, airport transfers, and city travel."
  },
  {
    "name": "Outstation Dzire Cab Pune",
    "description": "Outstation Swift Dzire cab service for trips beyond Pune, ensuring safety, comfort, and timely service."
  },
  {
    "name": "Affordable Dzire Cab Pune",
    "description": "Budget-friendly Swift Dzire cab rentals offering reliable and comfortable travel without overspending."
  },
  {
    "name": "Chauffeur Driven Dzire Cab",
    "description": "Professional drivers handle your Swift Dzire cab trip, ensuring a safe and hassle-free journey."
  },
  {
    "name": "Best Dzire Cab Pune",
    "description": "Top-rated Dzire cab service in Pune combining punctuality, comfort, and excellent customer support."
  },
  {
    "name": "Pune Dzire Taxi",
    "description": "Convenient Swift Dzire taxi service for city travel, family trips, and group rides within Pune."
  },
  {
    "name": "Corporate Dzire Cab Pune",
    "description": "Swift Dzire cabs for corporate travel, providing a professional and comfortable experience for employees."
  },
  {
    "name": "Family Dzire Cab Pune",
    "description": "Family-friendly Dzire cab rentals with spacious seating and comfort for all types of family trips."
  },
  {
    "name": "Airport Dzire Cab Pune",
    "description": "Swift Dzire cabs for timely airport pickups and drop-offs, ensuring smooth travel to and from Pune airport."
  },
  {
    "name": "Tourist Dzire Cab Pune",
    "description": "Dzire cabs for sightseeing and tourist trips in Pune, offering reliable service and flexible travel options."
  },
  {
    "name": "Local Dzire Cab Pune",
    "description": "Swift Dzire cabs for local Pune travel, including city commutes, shopping trips, and casual rides."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Book your Swift Dzire cab online in Pune with instant confirmation, secure payment, and hassle-free service."
  }
],
"tableData": [
  ["Swift Dzire on Rent in Pune", "Swift Dzire Cab Hire Pune"],
  ["AC Dzire Cab Pune", "Dzire Taxi Service Pune"],
  ["Outstation Dzire Cab Pune", "Affordable Dzire Cab Pune"],
  ["Chauffeur Driven Dzire Cab", "Best Dzire Cab Pune"],
  ["Pune Dzire Taxi", "Corporate Dzire Cab Pune"],
  ["Family Dzire Cab Pune", "Airport Dzire Cab Pune"],
  ["Tourist Dzire Cab Pune", "Local Dzire Cab Pune"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Swift Dzire on Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and affordable Swift Dzire rental services in Pune, perfect for city travel, airport transfers, outstation trips, and daily commuting."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced Swift Dzire cars for a smooth and comfortable journey anywhere in Pune or beyond."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers ensure safe, punctual, and hassle‑free travel, familiar with all major routes in Pune and nearby areas."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Swift Dzire rentals in Pune, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, one‑way, round‑trip, or customized rental plans to suit your requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Swift Dzire cars are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Swift Dzire rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Swift Dzire on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers comfortable and well‑maintained Swift Dzire cars for rent in Pune.'
  },
  {
    question: 'How can I book a Swift Dzire in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of trips can I take with a Swift Dzire rental?',
    answer: 'Swift Dzire rentals are suitable for city travel, airport transfers, outstation trips, and daily commuting.'
  },
  {
    question: 'Are drivers included in the Swift Dzire rental?',
    answer: 'Yes, all Swift Dzire rentals include experienced and professional drivers.'
  },
  {
    question: 'Is Swift Dzire rental service available 24x7?',
    answer: 'Yes, our Swift Dzire rental service in Pune is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all Swift Dzire cars are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize my Swift Dzire rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans based on your travel needs.'
  },
  {
    question: 'What payment options are available for Swift Dzire bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Swift Dzire trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Singh',
    feedback: 'Booked a Swift Dzire from Sanavi Travels in Pune. Very comfortable ride and professional service throughout!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Excellent experience! The car was clean, the driver was punctual, and the trip was smooth and enjoyable.',
    rating: 5
  }
];


















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Swift Dzire on Rent in Pune - Sanavi Travels",
//   "description": "Book Swift Dzire cabs in Pune with Sanavi Travels. AC and comfortable Dzire cabs for family trips, corporate travel, airport transfers, outstation journeys, local travel, tourist trips, and chauffeur-driven service.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.9",
//     "ratingCount": "1600"
//   }
// };

const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/swift-dzire-on-rent-in-pune#service",

  "name": "Swift Dzire on Rent in Pune",

  "serviceType": "Swift Dzire Car Rental",

  "description":
    "Sanavi Travels offers Swift Dzire on rent in Pune for airport transfers, local travel, corporate rides and outstation trips with a professional driver.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/swift-dzire-on-rent-in-pune"
};






  return (
    <div>


     <Helmet>
  <title>
    Swift Dzire on Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book a Swift Dzire on rent in Pune with Sanavi Travels for airport transfers, local travel, corporate rides and outstation trips. Comfortable sedan with professional driver."
  />

  <meta
    name="keywords"
    content="Swift Dzire on Rent in Pune, Dzire Cab Pune, Swift Dzire Taxi Pune, Dzire Rental Pune, Pune Airport Dzire Cab, Outstation Dzire Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/swift-dzire-on-rent-in-pune"
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Swift Dzire on Rent in Pune | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Book a Swift Dzire in Pune for local travel, airport transfers, corporate rides and outstation trips with a professional driver."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/swift-dzire-on-rent-in-pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/swift-dzire-on-rent-in-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
 
{/* <Helmet>
  <title>
    Swift Dzire on Rent in Pune | Affordable Taxi Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Swift Dzire on rent in Pune for airport transfers, local travel, outstation trips and corporate rides. Affordable, comfortable sedan with professional driver."
  />

  <meta
    name="keywords"
    content="Swift Dzire on Rent in Pune, Dzire Cab Pune, Swift Dzire Taxi Pune, Sedan Car Rental Pune, Pune Airport Dzire Cab, Outstation Dzire Pune, Cheap Cab Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/swift-dzire-on-rent-in-pune"
  />


  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Swift Dzire on Rent in Pune | Sanavi Travels"
  />
  <meta
    property="og:description"
    content="Affordable Swift Dzire cab service in Pune for airport, local travel, corporate trips and outstation rides."
  />
  <meta
    property="og:url"
    content="https://www.sanavitravels.com/swift-dzire-on-rent-in-pune"
  />

  
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Swift Dzire on Rent in Pune",
      "serviceType": "Sedan Taxi Service",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Sanavi Travels",
        "telephone": "+91 7387507373"
      },
      "areaServed": {
        "@type": "City",
        "name": "Pune"
      },
      "description":
        "Swift Dzire rental service in Pune for airport transfers, local travel, corporate rides and outstation trips at affordable prices.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": 4.7,
        "bestRating": 5,
        "worstRating": 1,
        "ratingCount": 10000
      }
    })}
  </script>
</Helmet> */}


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/swift-dzire-on-rent-in-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinpune;